import { CatSkeleton } from '@blocks-react/components/Skeleton';

export const EquipmentInfoLoader = () => {
  return (
    <div className="d-flex column-gap-2">
      <CatSkeleton width="64px" size="lg" />
      <div className="d-flex flex-column row-gap-2 w-100">
        <CatSkeleton className="w-75" size="sm" />
        <CatSkeleton className="w-100" size="sm" />
        <CatSkeleton className="w-100" size="sm" />
      </div>
    </div>
  );
};
